<template>
  <a-layout style="min-height: 100vh">
    <navbar />
    <a-layout class="app">
      <sidebar @openTab="onOpenTab" />
      <a-layout class="app-main" id="appMain">
        <a-tabs
          v-if="tabList.length"
          class="page-tabs"
          v-model:activeKey="activeKey"
          hide-add
          type="editable-card"
          @edit="handleTabsEdit"
          @tabClick="changeTab">
          <a-tab-pane
            v-for="tab in tabList"
            :key="tab.key"
            :tab="tab.title"
            :closable="tab.closable"
            >
          </a-tab-pane>
        </a-tabs>
        <a-layout-content class="main-content">
          <div class="content-surface">
            <router-view v-slot="{ Component }">
              <keep-alive :include="includeList" max="100">
                <component :is="Component" />
              </keep-alive>
            </router-view>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import { defineComponent, ref, watch, computed, onMounted, onBeforeUnmount } from 'vue'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { watermark } from 'watermark-dom'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {getMenus} from "@/api/admin-user";
import {message} from "ant-design-vue";

export default defineComponent({
  name: 'Layout',
  components: {
    Navbar,
    Sidebar
    // Breadcrumb
  },
  setup () {


    const store = useStore()

    const activeKey = ref(0);

    const onOpenTab = (routerObj) => {
      let path = routerObj.path;
      if (!path.startsWith("/")) {
        path = "/" + routerObj.path;
      }

      let tab = tabList.value.find(i => i.path == path);
      if (!tab) {
        tab = {path: path, title:routerObj.name, key: routerObj.id, closable: true}
      }

      activeKey.value = tab.key;

      if (tab.path !== currentTab) {
        store.dispatch('updateTabListState', tab)
        store.dispatch('updateCurrentTabState', tab.path)
      }
    }

    const changeTab = (key) => {
      activeKey.value = key;
      let tab = tabList.value.find(i => i.key == key);
      if (tab.path !== currentTab) {
        store.dispatch('updateTabListState', tab)
        store.dispatch('updateCurrentTabState', tab.path)
      }
    }

    const remove = (key) => {
      store.dispatch('removeCurrentTabState', key)
    }

    const handleTabsEdit = (key, action) => {
      if (action === 'remove') {
        remove(key)
        let tab = tabList.value.find(i => i.path == currentTab.value);
        activeKey.value = tab.key;
      }
    }

    const currentTab = computed(() => {
      return store.state.currentTab;
    });

    const tabList = computed(() => {
      return store.state.tabList;
    });

    const includeList = computed(() => {
      let list = store.state.tabList.map(item=>{
        return item.title
      })
      return list;
    })

    const includeKeyList = computed(() => {
      let list = store.state.tabList.map(item=>{
        return item.key
      })
      return list;
    })

    const router = useRouter()

    let currentPath = ref(router.currentRoute.value.path);

    watch(currentTab, (newValue, oldValue) => {
      router.push({ path: newValue })
    })

    const newLocalMenu = ref([])
    let nowTab;
    const initTab = () => {
      getMenus().then(res => {
        if (res.success) {
          newLocalMenu.value = newLocalMenu.value.concat(res.data.newMenu);
          findMenu(newLocalMenu.value, currentPath.value);
          if (nowTab) {
            onOpenTab(nowTab)
          }
          // 水印保留但压淡：0.2 的黑色盖在表格上太重，看数字很吃力。
          // 用户名取本次响应里的 loginVO：store 由 Sidebar 那次 getMenus 填，
          // 和这里有竞态，读 store 有时会拿到空值。
          const who = (res.data.loginVO && res.data.loginVO.userName) ||
                      store.state.userInfo.userName || '夕梦后台'
          watermark.load({
            watermark_txt: who,
            watermark_color: '#1B1B2B',
            watermark_fontsize: '14px',
            watermark_alpha: 0.045,
            watermark_width: 200,
            watermark_height: 200
          })
        } else {
          message.error(res.message)
        }
      }).catch(error => {
        message.error(error.message)
      }).finally(() => {
      })
    }

    const findMenu = (arr, path) => {
      arr.map((item) => {
        if (item.children && item.children.length > 0) {
          findMenu(item.children, path);
        } else {
           if (item.path === path) {
             nowTab = item;
           }
        }
      });
    }

    initTab();

    const handleContextEvent = (e) => {
      let className = e.srcElement.offsetParent.className;
      if (className && className.indexOf("ant-tabs-tab") > -1) {
        e.preventDefault();
        let textContent = e.srcElement.offsetParent.textContent;
        let index = includeList.value.indexOf(textContent);
        if (index > -1) {
          let key = includeKeyList.value[index];
          if (activeKey.value != key) {
            changeTab(key)
          }
        }
        let contextMenu = getContextMenu(true);
        if (contextMenu) {
          contextMenu.style.top = e.pageY + "px";
          contextMenu.style.left = e.pageX + "px";
        }
      } else {
        removeContextMenu();
      }
    }

    const handleClickEvent = () => {
      removeContextMenu();
    }

    onMounted(() => {
      document.addEventListener('contextmenu', handleContextEvent);
      document.addEventListener("click", handleClickEvent);
    })

    onBeforeUnmount(() => {
      document.removeEventListener('contextmenu', handleContextEvent);
      document.removeEventListener("click", handleClickEvent);
    })


    function getContextMenu(created) {

      let target = document.getElementById("menuContainer");
      if (target) {
        return target;
      }

      if (!created) {
        return null;
      }

      if (includeKeyList.value.length == 1) {
        return null;
      }

      target = document.createElement("div")
      target.id = "menuContainer";
      target.style.position = 'absolute';
      target.style.width = "120px";
      target.style.height = "100px";
      target.style.padding = "4px"
      target.style.backgroundColor = "#fff";
      target.style.boxShadow = "1px 1px 8px 2px #eee";

      let first = document.createElement("div");
      first.id = "closeOther";
      first.className = "menu-item";
      first.style.height = "30px";
      first.style.lineHeight = "30px";
      first.style.cursor = "pointer";
      first.innerHTML = "关闭其他标签页";
      first.addEventListener("click", handleCloseOther)
      target.appendChild(first);

      let second = document.createElement("div");
      second.id = "closeLeft";
      second.className = "menu-item";
      second.style.height = "30px";
      second.style.lineHeight = "30px";
      second.style.cursor = "pointer";
      second.innerHTML = "关闭左边标签页";
      second.addEventListener("click", handleCloseLeft)
      target.appendChild(second);

      let third = document.createElement("div");
      third.id = "closeRight";
      third.className = "menu-item";
      third.style.height = "30px";
      third.style.lineHeight = "30px";
      third.style.cursor = "pointer";
      third.innerHTML = "关闭右边标签页";
      third.addEventListener("click", handleCloseRight)
      target.appendChild(third);

      document.getElementById("appMain").appendChild(target);
      return target;
    }

    function removeContextMenu() {
      let contextMenu = getContextMenu(false);
      if (contextMenu) {
        contextMenu.children[0].removeEventListener("click", handleCloseOther);
        contextMenu.children[1].removeEventListener("click", handleCloseLeft);
        contextMenu.children[2].removeEventListener("click", handleCloseRight);
        contextMenu.remove();
      }
    }

    const handleCloseOther = () => {
      removeContextMenu();
      includeKeyList.value.forEach((ele, index) => {
        if (ele !== activeKey.value) {
          handleTabsEdit(ele, "remove");
        }
      })
    }

    const handleCloseLeft = () => {
      removeContextMenu();
      let nowIndex = includeKeyList.value.indexOf(activeKey.value);
      includeKeyList.value.forEach((ele, index) => {
        if (index < nowIndex) {
          handleTabsEdit(ele, "remove");
        }
      })
    }

    const handleCloseRight = () => {
      removeContextMenu();
      let nowIndex = includeKeyList.value.indexOf(activeKey.value);
      includeKeyList.value.forEach((ele, index) => {
        if (index > nowIndex) {
          handleTabsEdit(ele, "remove");
        }
      })
    }

    return {
      onOpenTab,
      remove,
      handleTabsEdit,
      tabList,
      includeList,
      activeKey,
      changeTab,
    }
  }
})
</script>

<style lang="less" scoped>
@import '@/style/variables.less';

.app-main {
  background: @bg-body;
  min-width: 0;   // 没有它，宽表格会把整个 flex 布局撑破
}

// 页签条：原来是 antd 的 editable-card，方块+ 粗边框，很旧。
// 改成贴在顶部的一条，选中项用主色下划线。
.page-tabs {
  background: @bg-surface;
  border-bottom: 1px solid @border-1;
  padding: 0 16px;

  :deep(.ant-tabs-nav) { margin: 0; }
  :deep(.ant-tabs-nav::before) { display: none; }

  :deep(.ant-tabs-tab) {
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 10px 14px !important;
    color: @text-3;
    font-size: 13px;
    position: relative;
    transition: color .15s ease;

    &:hover { color: @text-1; }

    // 选中态的主色下划线
    &::after {
      content: '';
      position: absolute;
      left: 12px; right: 12px; bottom: 0;
      height: 2px;
      background: transparent;
      transition: background .15s ease;
    }
  }

  :deep(.ant-tabs-tab-active) {
    color: @brand-600 !important;
    font-weight: 500;
    &::after { background: @brand-500; }
    .ant-tabs-tab-btn { color: @brand-600 !important; }
  }

  :deep(.ant-tabs-tab-remove) {
    color: @text-4;
    margin-left: 6px;
    &:hover { color: @danger; }
  }
}

.main-content {
  padding: 16px;
  overflow: auto;
}

// 内容卡片。原来 padding 直接打在 a-layout-content 上，
// 页面和底色之间没有边界，表格像是浮在背景上。
.content-surface {
  background: @bg-surface;
  border: 1px solid @border-1;
  border-radius: @radius-lg;
  padding: 20px;
  min-height: calc(100vh - @header-h - 42px - 32px);
}

// 右键页签菜单（layout 里用原生 DOM 建的），补一下悬停反馈
:deep(#menuContainer) {
  border-radius: @radius-md;
  border: 1px solid @border-1;
  .menu-item {
    padding: 0 8px;
    border-radius: @radius-sm;
    font-size: 13px;
    color: @text-2;
    &:hover { background: @bg-hover; color: @brand-500; }
  }
}
</style>
